import { ArrowRight } from "lucide-react";
import { PIPELINE_STAGES } from "./flowData";

/** First word of the stage title, used as a short pill label. */
function shortLabel(title: string): string {
  return title.split(" ")[0] ?? title;
}

/**
 * Compact horizontal overview of the AI pipeline, derived from
 * PIPELINE_STAGES (in their corrected order). Each stage shows its icon,
 * accent color and a short label.
 */
export function PipelineOverview() {
  return (
    <div className="overflow-x-auto pb-2">
      <div className="flex items-center justify-center gap-2 min-w-[640px]">
        {PIPELINE_STAGES.map((stage, i) => {
          const Icon = stage.icon;
          return (
            <div key={stage.stage} className="flex items-center gap-2">
              <div className="flex flex-col items-center gap-1.5">
                <div
                  className={`flex items-center justify-center size-10 rounded-full ${stage.color.bg}`}
                >
                  <Icon className={`size-5 ${stage.color.text}`} />
                </div>
                <span className="text-xs font-medium text-muted-foreground">
                  {shortLabel(stage.title)}
                </span>
              </div>
              {i < PIPELINE_STAGES.length - 1 && (
                <ArrowRight className="size-4 text-muted-foreground/40 mb-5" />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
